import { service } from '@ember/service';
import Component from '@glimmer/component';

import { trackedFunction } from 'reactiveweb/function';

import ContentItems from 'umg-ember-backend/components/page-builder/content-items';

export default class PageBuilderContentItemsItemForPageBuilderVoucher extends Component {
  // Services
  @service media;
  @service pageBuilderFrontendApi;

  // Getter and setter
  get voucherConfig() {
    return this.themeConfig?.cms?.['mlp-voucher'];
  }

  get themeConfig() {
    return this.loadThemeConfig.value;
  }

  // Functions
  loadThemeConfig = trackedFunction(this, async () => {
    return await this.pageBuilderFrontendApi.loadThemeConfig(
      this.pageBuilderFrontendApi.host,
      this.args.mlp,
    );
  });

  // Template
  <template>
    <ContentItems
      @contentItems={{@contentItem.children}}
      @contentItemTypeOptions={{this.voucherConfig.contentItems}}
      @direction='y'
      @isDisabled={{@isDisabled}}
      @mlp={{@mlp}}
      @onSelectContentItem={{@onSelectContentItem}}
      @onSaveMlp={{@onSaveMlp}}
      @parent={{@contentItem}}
      @selectedContentItem={{@selectedContentItem}}
    />
  </template>
}
